import React, { useState, useEffect, useContext } from 'react';
import Logo from '../components/Logo';
import Divider from '@mui/joy/Divider';
import Box from '@mui/joy/Box';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { useLocation, Link as RouterLink, useNavigate } from 'react-router-dom';
import { Sheet, Stack, Button, IconButton } from '@mui/joy';
import PhoneIcon from '@mui/icons-material/Phone';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CloseIcon from '@mui/icons-material/Close';
import UserContext from '../context/UserContext';
import axiosInstance from '../util/axiosConfig';


const Header = ({ breadcrumbsData }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const [searchingLeads, setSearchingLeads] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);

    // Function to generate breadcrumbs based on current location and provided data
    const getBreadcrumbs = () => {
        // Default breadcrumb (Home)
        const defaultCrumbs = [{
            path: '/',
            label: 'Home',
            icon: <HomeRoundedIcon sx={{ mr: 0.5 }} />
        }];

        // If breadcrumbsData is provided, use it
        if (breadcrumbsData && breadcrumbsData.length > 0) {
            return [...defaultCrumbs, ...breadcrumbsData];
        }

        // Otherwise, generate from current path
        const pathnames = location.pathname.split('/').filter(x => x);
        if (pathnames.length === 0) return defaultCrumbs;

        return [
            ...defaultCrumbs,
            ...pathnames.map((value, index) => {
                const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                return {
                    path: to,
                    label: value.charAt(0).toUpperCase() + value.slice(1)
                };
            })
        ];
    };

    const breadcrumbs = getBreadcrumbs();

    return (
        <div>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    py: '6px',
                    px: 2
                }}
            >
                <Logo width={150} height={50} clickable={false} />

                {/* Right side: Breadcrumbs and Notification Bell */}
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 2
                }}>
                    <Breadcrumbs
                        size="lg"
                        separator={<ChevronRightRoundedIcon sx={{ color: '#ea7a23' }} />}
                        sx={{
                            '--Breadcrumbs-gap': '1rem',
                            '--Icon-fontSize': '16px',
                            fontWeight: 'lg',
                            p: 0
                        }}
                    >
                        {breadcrumbs.map((crumb, index) => {
                            const isLast = index === breadcrumbs.length - 1;

                            return isLast ? (
                                <Typography
                                    key={crumb.path}
                                    sx={{
                                        color: '#ea7a23',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5
                                    }}
                                >
                                    {crumb.icon}
                                    {crumb.label}
                                </Typography>
                            ) : (
                                <Link
                                    key={crumb.path}
                                    component={RouterLink}
                                    to={crumb.path}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5,
                                        textDecoration: 'none',
                                        '&:hover': {
                                            color: '#ea7a23'
                                        }
                                    }}
                                >
                                    {crumb.icon}
                                    {crumb.label}
                                </Link>
                            );
                        })}
                    </Breadcrumbs>
                </Box>
            </Box>
        </div>
    );
};

export default Header;